import { writable } from 'svelte/store';
import { setContext } from 'svelte';
export const createFieldContext = (name, value, error, disabled, empty, detail) => {
    const key = Symbol();
    const fieldContext = {
        name: name ?? '',
        value: writable(value),
        error: writable(error),
        disabled: writable(disabled),
        empty: writable(empty),
        focus: writable(false),
        dirty: writable(false),
        visited: writable(false),
        activity: writable(false)
    };
    if (detail !== undefined) {
        fieldContext.detail = writable(detail);
    }
    setContext(key, fieldContext);
    return key;
};
export const mergeFieldState = (s0, s1) => {
    return {
        empty: s0?.empty === undefined ? s1.empty : s1?.empty === undefined ? s0.empty : s0.empty || s1.empty,
        dirty: s0?.dirty === undefined ? s1.dirty : s1?.dirty === undefined ? s0.dirty : s0.dirty || s1?.dirty,
        focus: s0?.focus === undefined ? s1.focus : s1?.focus === undefined ? s0.focus : s0.focus || s1.focus,
        visited: s0?.visited === undefined ? s1.visited : s1?.visited === undefined ? s0.visited : s0.visited || s1.visited,
        disabled: s0?.disabled === undefined ? s1.disabled : s1?.disabled === undefined ? s0.disabled : s0.disabled || s1.disabled
    };
};
export const mergeFieldStateChanges = (s0, s1) => {
    const changes = {};
    if (s0?.empty !== undefined || s1?.empty !== undefined) {
        changes.empty = s0?.empty === undefined ? s1.empty : s1?.empty === undefined ? s0.empty : s0.empty || s1.empty;
    }
    if (s0?.dirty !== undefined || s1?.dirty !== undefined) {
        changes.dirty = s0?.dirty === undefined ? s1.dirty : s1?.dirty === undefined ? s0.dirty : s0.dirty || s1.dirty;
    }
    if (s0?.focus !== undefined || s1?.focus !== undefined) {
        changes.focus = s0?.focus === undefined ? s1.focus : s1?.focus === undefined ? s0.focus : s0.focus || s1.focus;
    }
    if (s0?.visited !== undefined || s1?.visited !== undefined) {
        changes.visited = s0?.visited === undefined ? s1.visited : s1?.visited === undefined ? s0.visited : s0.visited || s1.visited;
    }
    if (s0?.disabled !== undefined || s1?.disabled !== undefined) {
        changes.disabled = s0?.disabled === undefined ? s1.disabled : s1?.disabled === undefined ? s0.disabled : s0.disabled || s1.disabled;
    }
    return changes;
};
export const mergeStateEventDetails = (s0, s1) => {
    return { changes: mergeFieldStateChanges(s0?.changes, s1?.changes), state: mergeFieldState(s0?.state, s1?.state) };
};
